import { EventEmitter, Injectable, Output } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class TablistService {
  private tabsArray: tabModel[] = [];
  @Output() arrayUpdated = new EventEmitter<any>();
  constructor() {
  }

  createTab(tab: tabModel) {
    this.tabsArray.push(tab);
    this.emitListofTabs();
  }
  returnIndexName(index: number) {
    return this.tabsArray[index].name;
  }
  tabCount() {
    return this.tabsArray.length;
  }
  emitListofTabs(){
   this.arrayUpdated.emit(this.tabsArray); 
  }
  removeTab(elementId:string){
    var index = this.tabsArray.findIndex(x => x.elementId == elementId); 
    if(index >= 0){
      this.tabsArray.splice(index, 1)
    }  
    this.emitListofTabs();
  }

}

export class tabModel {
  elementId: string = "";
  name: string = ""; 
  modalService: any = undefined; 
  model: any = undefined;
  other: any = undefined;
}
